import {
    FETCH_API_KEYS,
    FETCH_API_KEYS_FAILURE,
    FETCH_API_KEYS_SUCCESS,

    FETCH_API_KEY,
    FETCH_API_KEY_FAILURE,
    FETCH_API_KEY_SUCCESS,
} from 'store/actions/types';

export const fetchApiKeys = (payload) => {

    const params = {
        size: payload.size || 24,
        sort_by: payload.field || 'name',
        sort_direction: payload.order || 'asc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    return {
        type: FETCH_API_KEYS,
        payload: params,
    };
};

export const fetchApiKeysFailure = (error) => {
    return {
        type: FETCH_API_KEYS_FAILURE,
        error: error,
    };
};

export const fetchApiKeysSuccess = (payload) => {
    return {
        type: FETCH_API_KEYS_SUCCESS,
        payload: payload,
    };
};

// Fetch API key
export const fetchApiKey = (payload) => {
    return {
        type: FETCH_API_KEY,
        payload: payload,
    };
};

export const fetchApiKeyFailure = (error) => {
    return {
        type: FETCH_API_KEY_FAILURE,
        error: error,
    };
};

export const fetchApiKeySuccess = (payload) => {
    return {
        type: FETCH_API_KEY_SUCCESS,
        payload: payload,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/apiKeys/fetchApiKeys.js